import { render } from "./saleDetail.vue?vue&type=template&id=7e9f717b&scoped=true"
import script from "./saleDetail.vue?vue&type=script&lang=js"
export * from "./saleDetail.vue?vue&type=script&lang=js"

import "./saleDetail.vue?vue&type=style&index=0&id=7e9f717b&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e9f717b"]])

export default __exports__